import { v4 as uuid, v1 } from "uuid";

export default class StringsFuncs {
  val: string;
  newVal: string;

  constructor(val: string | number = "") {
    this.val = val.toString();
    this.newVal = "";
  }

  cammelCase = (): string => {
    if (this.val !== null && this.val !== undefined && this.val !== "") {
      var list = this.val.toLowerCase().split(/(\s+)/);

      list.map((e) => {
        if (e.trim() !== "") {
          if (this.newVal === "") {
            this.newVal = e.charAt(0).toUpperCase() + e.slice(1);
          } else {
            this.newVal = this.newVal.concat(
              " " + e.charAt(0).toUpperCase() + e.slice(1)
            );
          }
        }

        return true;
      });
    }

    return this.newVal;
  };

  capitalLetter = (): string => {
    if (this.val !== null && this.val !== undefined && this.val !== "") {
      this.newVal = this.val.toLowerCase();
      const arr = this.newVal.split(" ");

      for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }

      this.newVal = arr.join(" ");
    }
    return this.newVal;
  };

  firstLetters = (): string => {
    this.val.split(" ").map((w: string) => {
      this.newVal = this.newVal.concat(w.substring(0, 1).toUpperCase());
      return true;
    });

    return this.newVal;
  };

  generateCode = (): string => {
    return uuid().toString();
  };

  generateSmallCode = (): string => {
    const code = v1().toString().split("-");
    return `${code[0]}${code[1]}`;
  };

  removeAccents = () => {
    return this.val
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  };

  parseNumberLetter = (num: number): string => {
    if (num < 1) {
      throw new Error("O número deve ser maior ou igual a 1.");
    }

    let resultado = "";
    while (num > 0) {
      num--; // Ajuste para indexação começar em 0
      const resto = num % 26;
      resultado = String.fromCharCode(65 + resto) + resultado; // 65 é o código ASCII para 'A'
      num = Math.floor(num / 26);
    }

    return resultado;
  };

  dimmensionsArea = (
    totalCols: number,
    totalLines: number,
    initCol = 1,
    initLine = 1
  ): string => {
    const dimmension = `${this.parseNumberLetter(initCol)}${initLine}:${this.parseNumberLetter(totalCols)}${totalLines}`;
    return dimmension;
  };

  formatarNumeroMilhar = (zerosEsquerda = 5) => {
    // Converte o número para string e completa com zeros à esquerda
    const numeroString = String(this.val).padStart(zerosEsquerda, "0");

    // Utiliza a expressão regular para adicionar os pontos a cada 3 dígitos
    // da direita para a esquerda.
    return numeroString.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  };
}
